import { APPROVED, REJECTED, SUBMITTED } from "@equidefi/constants/accreditation";
import type { DTO } from "@equidefi/shared/types/dto";
import { Icon } from "@equidefi/ui/icon";
import type React from "react";

import { VAULT_ROUTES } from "@/constants/routes";

import { InvestmentStepCard } from "./InvestmentStepCard";

export const AccreditationStepCard: React.FC<{ investment: DTO.Investment }> = ({ investment }) => {
  const to = VAULT_ROUTES.accreditation(investment.id);
  const status = investment.vault?.status;

  if (investment.accreditation_status === "success" || status === APPROVED) {
    return (
      <InvestmentStepCard
        scheme="green"
        label="APPROVED"
        heading="Accreditation Approved"
        text="The documents you submitted have been approved and your accreditation has been verified."
        icon={Icon.FileText}
        to={to}
      />
    );
  }

  if (status === REJECTED) {
    return (
      <InvestmentStepCard
        scheme="red"
        label="REJECTED"
        heading="Accreditation Rejected"
        text="The documents you submitted were rejected. Please re-submit your accreditation."
        icon={Icon.FileText}
        to={to}
      />
    );
  }

  if (status === SUBMITTED) {
    return (
      <InvestmentStepCard
        scheme="blue"
        label="IN REVIEW"
        heading="Accreditation Submitted"
        text="Your verification documents are awaiting review."
        icon={Icon.FileText}
        to={to}
      />
    );
  }

  return (
    <InvestmentStepCard
      scheme="yellow"
      label="PENDING"
      heading="Accreditation Pending"
      text="Upload documentation to prove your accreditation status."
      icon={Icon.FileText}
      to={to}
    />
  );
};

export default AccreditationStepCard;
